import { setAppErrors, setSystemFormButtonSave } from '../../action/system'
import { retrieveErrorFromApi } from '../../../helper'
import createCategory from '../../axios/cashBookNew/createCategory'
import { appendCashBookNewCashBooks, setCashBookNewAcceptInitialBalance, setCashBookNewBalanceOfOldCashBookWasAccepted, setCashBookNewCashBalance, setCashBookNewCashBookId, setCashBookNewCashBooks, setCashBookNewCashBooksTotalLength, setCashBookNewCategories, setCashBookNewCategoryId, setCashBookNewInitialBalanceOldCashBook, setCashBookNewLoading, setCashBookNewLoadingDateV, setCashBookNewShowTransactionErrorModal } from '../../action/cashbookNew'
import getAllCategories from '../../axios/cashBookNew/getAllCategories'
import createCashBook from '../../axios/cashBookNew/post'
import { downloadFile } from '../../../helper/downloadFile'
import { getCashBookRecordsZIPFile } from '../../axios/cashBookNew/getCashBookRecordsZIPFile'
import getAllCashBooks from '../../axios/cashBookNew'
import updateTransaction from '../../axios/cashBookNew/put'
import cancelTransaction from '../../axios/cashBookNew/cancelTransaction'
import getAcceptInitialBalanceForOldCashBook from '../../axios/cashBookNew/getAcceptInitialBalance'
import getInitialBalanceOldCashBook from '../../axios/cashBookNew/getInitialBalanceOldCashBook'
import acceptInitialBalance from '../../axios/cashBookNew/acceptInitialBalance'
import initialBalanceForCashBook from '../../axios/cashBookNew/initialBalanceForCashBook'
import getCashBalance from '../../axios/cashBookNew/getCashBalance'
import deleteCategory from '../../axios/cashBookNew/deleteCategory'
import updateCategoryOfCashBook from '../../axios/cashBookNew/updateCategory'
import { getCashBookRecordsFormatDateV } from '../../axios/cashBookNew/getCashBookRecordsFormatDateV'
import getIsAccountingData from '../../axios/cashBookNew/getIsAccountingData'
import createTestReport from '../../axios/fiscal/report/test/post'
import { resetSystemFormButtonSaveThunk, succeedSystemFormButtonSaveThunk } from '../app'
import getCashActiveStatus from '../../axios/cashBookNew/getActiveStatus'

const PER_LOAD = 10
export const createCategoryOfCashBookThunk = (data, isSettingCategories) => dispatch => {
	dispatch(setSystemFormButtonSave({ processing: true }))
	return createCategory(data)
		.then(res => {
			dispatch(succeedSystemFormButtonSaveThunk())
			if (!isSettingCategories) {
				dispatch(setCashBookNewCategoryId(res.data.remoteResponse.id))
			}
			return dispatch(getAllCategoriesThunk(data.transactionType))
		})
		.catch(error => {
			dispatch(resetSystemFormButtonSaveThunk())
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const getAllCategoriesThunk = (transactionType, callbackSuccess) => dispatch => {
	return getAllCategories(transactionType)

		.then(res => {
			dispatch(setCashBookNewCategories(res.data))
			if (typeof callbackSuccess === 'function') callbackSuccess()
		})
		.catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const getCashBookRecordsZIPFileThunk = (dateFrom, dateTo, callbackSuccess) => dispatch => {
	return getCashBookRecordsZIPFile(dateFrom, dateTo)
		.then((response) => {
			dispatch(setCashBookNewLoading(false))
			const nameFile = `Kassenbuch_perioduebersicht_von_${dateFrom}_bis_${dateTo}.zip`
			downloadFile(response, nameFile)
			if (typeof callbackSuccess === 'function') callbackSuccess()
		})
		.catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const getAllCashBooksThunk = (page = 0, size = PER_LOAD, dateFrom, dateTo) => dispatch => {
	return getAllCashBooks(page, size, dateFrom, dateTo)
		.then((res) => {
			if (res && res.data) {

				if (res.headers['x-cash-books-total']) {
					dispatch(setCashBookNewCashBooksTotalLength(parseInt(res.headers['x-cash-books-total'])))
				}
				if (page > 0 && size > 0) {
					dispatch(appendCashBookNewCashBooks(res.data))
					return
				}
				dispatch(setCashBookNewCashBooks(res.data))
			}
		}).catch((error) => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const createCashBookThunk = (data) => dispatch => {
	dispatch(setSystemFormButtonSave({ processing: true }))
	return createCashBook(data)
		.then(res => {
			dispatch(succeedSystemFormButtonSaveThunk())
			dispatch(setCashBookNewCashBookId(res.data.remoteResponse.id))
		})
		.catch(error => {
			dispatch(resetSystemFormButtonSaveThunk())
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const cancelTransactionThunk = (paymentTransactionId, data) => dispatch => {
	return cancelTransaction(paymentTransactionId, data)
		.then((res) => {
		})
		.catch(error => {
			const errorStatusCode = error.response.data?.apierror.errorStatusCode
			const canceledRecord = errorStatusCode === 'record_already_canceled'
			if (canceledRecord) {
				dispatch(setCashBookNewShowTransactionErrorModal(true))
			} else {
				dispatch(setAppErrors(retrieveErrorFromApi(error)))
			}
		})
}

export const updateTransactionThunk = (paymentTransactionId, data) => dispatch => {
	dispatch(setSystemFormButtonSave({ processing: true }))
	return updateTransaction(paymentTransactionId, data)
		.then((res) => {
			dispatch(succeedSystemFormButtonSaveThunk())
		})
		.catch(error => {
			dispatch(resetSystemFormButtonSaveThunk())
			const errorStatusCode = error.response.data?.apierror.errorStatusCode
			const canceledRecord = errorStatusCode === 'record_already_canceled'
			if (canceledRecord) {
				dispatch(setCashBookNewShowTransactionErrorModal(true))
			} else {
				dispatch(setAppErrors(retrieveErrorFromApi(error)))
			}
		})
}

export const getInitialBalanceOldCashBookThunk = () => dispatch => {
	return getInitialBalanceOldCashBook()
		.then(res => {
			dispatch(setCashBookNewInitialBalanceOldCashBook(res.data.initialBalance))
		})
		.catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const getAcceptInitialBalanceForOldCashBookThunk = () => dispatch => {
	return getAcceptInitialBalanceForOldCashBook()
		.then(res => {
			dispatch(setCashBookNewBalanceOfOldCashBookWasAccepted(res.data))
		})
		.catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const acceptInitialBalanceOldCashBookThunk = (data) => dispatch => {
	return acceptInitialBalance(data)
		.then(res => {
			dispatch(setCashBookNewAcceptInitialBalance(data))
		})
		.catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const initialBalanceForCashBookThunk = (data, callbackSuccess) => dispatch => {
	return initialBalanceForCashBook(data)
		.then(res => {
			if (typeof callbackSuccess === 'function') callbackSuccess()
		})
		.catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		}).finally(
			dispatch(setCashBookNewLoading(false))
		)
}

export const getCashBalanceThunk = () => dispatch => {
	return getCashBalance()
		.then(res => {
			dispatch(setCashBookNewCashBalance(res.data))
		})
		.catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const deleteCategoryOfCashBookThunk = (categoryId, transactionType) => dispatch => {
	return deleteCategory(categoryId)
		.then(res => {
			return dispatch(getAllCategoriesThunk(transactionType))
		})
		.catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const updateCategoryOfCashBookThunk = (categoryId, data) => dispatch => {
	dispatch(setSystemFormButtonSave({ processing: true }))
	return updateCategoryOfCashBook(categoryId, data)
		.then(res => {
			dispatch(succeedSystemFormButtonSaveThunk())
			return dispatch(getAllCategoriesThunk(data?.transactionType))
		})
		.catch(error => {
			dispatch(resetSystemFormButtonSaveThunk())
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const getCashBookRecordsFormatDateVThunk = (dateFrom, dateTo, callbackSuccess) => dispatch => {

	return getCashBookRecordsFormatDateV(dateFrom, dateTo)
		.then((response) => {
			dispatch(setCashBookNewLoadingDateV(false))
			const nameFile = `Kassenbuch_perioduebersicht_datev_von_${dateFrom}_bis_${dateTo}.zip`
			downloadFile(response, nameFile)
			if (typeof callbackSuccess === 'function') callbackSuccess()
		})
		.catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const getCashBookIsAccountingDataThunk = (handleOpenNavigationModalToDateV, handleExportRecordsFormatDateV) => dispatch => {
	return getIsAccountingData()
		.then(res => {
			if (res.data.exists) {
				if (typeof handleExportRecordsFormatDateV === 'function') handleExportRecordsFormatDateV()

			} else {
				if (typeof handleOpenNavigationModalToDateV === 'function') handleOpenNavigationModalToDateV()
			}
		})
		.catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const createTestZReportForCashBookNewThunk = () => (dispatch) => {
	return createTestReport()
		.then(res => {
		}).catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const getActiveStatusForNewCashBookThunk = () => async dispatch => {
	try {
		const res = await getCashActiveStatus()
		return res.data.check
	}
	catch(error) {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		}
}

